<template>
    <div class="inline-flex">
        <span v-for="(t,i) in Tabs" :key="i" class="border-b-2 p-2 flex mr-3"
              :class="{'border-b-next-orange': i===Radio}">
            <label>
                <input class="hidden" type="radio" v-model="Radio" :value="i"/>
                <input v-if="!Readonly && editing_index === i && this.isEditing" v-model="t.titolo" ref="mod"
                       @keydown.enter.prevent="disableEditable" @keydown.tab.prevent="disableEditable">
                <span v-else @dblclick="enableEditable(i)" class="select-none cursor-pointer"
                      :class="{'font-bold text-next-orange': i===Radio}">{{ t.titolo }}</span>
            </label>
            <span class="pl-2" v-if="isEditing">
                <i @click="disableEditable" class="text-sm icon-floppy cursor-pointer hover:text-next-orange"></i>
            </span>
            <span class="pl-2" v-else-if="!Readonly && !Disabled && i===Radio">
                <i @click="$emit('duplicatab', i)"
                   class="text-sm icon-duplica cursor-pointer hover:text-next-orange"></i>
            </span>
            <span class="pl-2" v-if="!Readonly && !Disabled && allowDelete">
                <ConfirmDelete @cancella="cancella(i)">
                    <i class="text-sm icon-x"></i>
                </ConfirmDelete>
            </span>
        </span>
        <span v-if="!Readonly && !Disabled" class="flex items-center">
            <i @click="$emit('addtab')" class="icon-croce_cerchiata cursor-pointer"></i>
        </span>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import ConfirmDelete from "@/components/ConfirmDelete.vue";

@Options({
    name: 'Tabs',
    components: {ConfirmDelete},
    props: {
        tabs: Array,
        modelValue: Number,
        allowDelete: {
            type: Boolean,
            default: true
        }
    },
    emits: ['addtab', 'removetab', 'update:modelValue', 'duplicatab', 'editingChange']
})
export default class Tabs extends Vue {

    get Readonly() {
        return this.$attrs['readonly'] !== undefined
    }

    is_editing = false
    editing_index = -1
    modelValue!: number
    tabs!: any[]

    get Tabs() {
        if (this.Disabled) {
            return [this.tabs[this.modelValue]]
        }
        return this.tabs
    }

    get Disabled() {
        return this.$attrs.disabled
    }

    enableEditable(i: number) {
        if (!this.Readonly && !this.isEditing) {
            this.editing_index = i
            this.isEditing = true
            this.$nextTick(() => {
                if (this.$refs['mod']) {
                    //@ts-ignore
                    this.$refs['mod'].forEach((el) => el.focus())
                }
            })
        }
    }

    get isEditing() {
        return this.is_editing
    }

    set isEditing(val: boolean) {
        this.is_editing = val
        this.$emit('editingChange', val)
    }

    disableEditable() {
        this.isEditing = false
    }

    cancella(i: number) {
        this.disableEditable()
        this.$emit('removetab', i)
    }

    get Radio() {
        return this.modelValue
    }

    set Radio(value) {
        if (!this.isEditing && !this.Disabled) {
            this.$emit('update:modelValue', value)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
